"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var colors_1 = require("../../theme/colors");
var icons_1 = require("../icons");
var input_1 = require("../input");
var spinner_1 = require("../spinner");
var text_1 = require("../text");
function ObjectSelector(_a) {
    var _b = _a.loading, loading = _b === void 0 ? false : _b, error = _a.error, placeholder = _a.placeholder, children = _a.children, _c = _a.searchPlaceholder, searchPlaceholder = _c === void 0 ? 'Filter by keyword' : _c, searchInput = _a.searchInput, onSearchInputChange = _a.onSearchInputChange, _d = _a.containerHeight, containerHeight = _d === void 0 ? 380 : _d;
    var hasChildren = !!children && react_1.default.Children.count(children) > 0;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(input_1.Input, { type: "search", placeholder: searchPlaceholder, style: {
                borderLeft: 0,
                borderRight: 0,
                borderRadius: 0,
                marginTop: -1,
                boxShadow: 'none',
                paddingLeft: 40,
            }, value: searchInput, onChange: onSearchInputChange }),
        react_1.default.createElement("div", { style: {
                height: containerHeight,
                overflowY: 'auto',
                background: colors_1.colors.steel[100],
                paddingBottom: 16,
                position: 'relative',
            } },
            loading && react_1.default.createElement(spinner_1.CircleSpinner, null),
            !loading && error && (react_1.default.createElement(Centered, null,
                react_1.default.createElement(icons_1.IconWarning, null),
                react_1.default.createElement(text_1.Text, { color: "default" }, error))),
            children,
            !hasChildren && !error && !loading && (react_1.default.createElement(Centered, null,
                react_1.default.createElement(text_1.Text, { color: "default" }, placeholder))))));
}
exports.default = ObjectSelector;
var Centered = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  max-width: 520;\n"], ["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  max-width: 520;\n"])));
var templateObject_1;
//# sourceMappingURL=index.js.map